"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _canUseDOM = _interopRequireDefault(require("../utils/canUseDOM"));

var _getElement = require("../utils/getElement");

var _isEmptyObject = _interopRequireDefault(require("../utils/isEmptyObject"));
/*!
 * VERSION: 0.0.1
 * DATE: 2018-06-08
 * UPDATES AND DOCS AT: TBD
 *
 *
 * @author: Matthew Rumery, matthew@rumery.io
 */

/* eslint-disable no-underscore-dangle, react/no-this-in-sfc */


class Scrollix {
  constructor(_ref) {
    let {
      root = undefined,
      rootMargin = '0px',
      threshold: _threshold = 1,
      thresholdSteps = undefined,
      targetElement = '',
      targetMultiple: _targetMultiple = false,
      onlyOnce = false,
      targetTween = {},
      scrollBased = false,
      infinite = false,
      reverse = false
    } = _ref;
    let callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;
    (0, _defineProperty2.default)(this, "_buildElement", function (element) {
      let targetMultiple = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      let elements = [];
      elements = (0, _getElement.getElement)(element);

      if (targetMultiple) {
        elements = (0, _getElement.getElement)(element, targetMultiple);
      }

      return elements;
    });
    (0, _defineProperty2.default)(this, "_buildRootMargin", () => {
      /* rootMargin
       * Margin around the root. Can have values similar to the CSS margin property,
       * e.g. "10px 20px 30px 40px" (top, right, bottom, left).
       * The values can be percentages.
       * This set of values serves to grow or shrink each side of the
       * root element's bounding box before computing intersections. Defaults to all zeros.
       */
      const regex = RegExp(/^-?(\d*)\.?(\d+)(px|%)/);

      const values = this._rootMargin.split(/\s+/);

      const correctValues = values.map(value => {
        if (regex.test(value)) {
          return value;
        }

        throw new TypeError('rootMargin must be a string of 4 values either with px or % or a combination of both.');
      });
      return correctValues.join(' ');
    });
    (0, _defineProperty2.default)(this, "_buildThreshold", function () {
      let threshold = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      let steps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      /* threshold
       * Either a single number or an array of numbers which indicate at what
       * percentage of the target's visibility the observer's callback should
       * be executed. If you only want to detect when visibility passes the 50% mark,
       * you can use a value of 0.5. If you want the callback run every time
       * visibility passes another 25%, you would specify the array [0, 0.25, 0.5, 0.75, 1].
       * The default is 0 (meaning as soon as even one pixel is visible,
       * the callback will be run). A value of 1.0 means that the threshold
       * isn't considered passed until every pixel is visible.
       */
      if ('number' !== typeof threshold && !Array.isArray(threshold)) {
        throw new TypeError('threshold must be either a number or an array of numbers.');
      } else if (!Array.isArray(threshold) && 1 < threshold || 0 > threshold) {
        throw new TypeError('threshold must contain a value between 0.0 and 1.0.');
      } else if (Array.isArray(threshold)) {
        threshold.forEach(v => {
          if ('number' !== typeof v) {
            throw new TypeError('values in threshold array must be an integer or float.');
          } else if (1 < v || 0 > v) {
            throw new TypeError('values in threshold array myst be between 0.0 and 1.0.');
          }
        });
      }

      let thresholds = [];

      if (!steps && 1 !== steps) {
        if (Array.isArray(threshold)) {
          thresholds = threshold.indcludes(0) ? [...threshold] : [0, ...threshold];
        }

        thresholds = [0, threshold];
      }

      if (steps && 1 !== steps) {
        // eslint-disable-next-line no-plusplus
        for (let i = 1.0; i <= steps; i++) {
          thresholds = [...thresholds, i / steps];
        }

        thresholds = [0, ...thresholds];
      }

      return thresholds;
    });
    (0, _defineProperty2.default)(this, "_createObserver", () => {
      /* root
       * The element that is used as the viewport for checking visiblity of the target.
       * Must be the ancestor of the target.
       * Defaults to the browser viewport if not specified or if null.
       */
      if (_canUseDOM.default) {
        this.observer = new IntersectionObserver(this.handleIntersection, {
          root: (0, _getElement.getElement)(this._root),
          rootMargin: this._buildRootMargin(this._rootMargin),
          threshold: this._buildThreshold(this._threshold, this._thresholdSteps)
        });
        this.observeElement(this._targetElement);
      }

      return null;
    });
    (0, _defineProperty2.default)(this, "observeElement", element => {
      const targets = this._buildElement(element, this._targetMultiple);

      return targets.map(target => this.observer.observe(target));
    });
    (0, _defineProperty2.default)(this, "handleIntersection", (entries, observer) => entries.map(entry => {
      if (entry.intersectionRatio >= this._threshold && entry.isIntersecting) {
        this.handleCallback(entry); // TODO: remove this out into child scrollix for gsap animations

        if (!(0, _isEmptyObject.default)(this._targetTween) && !this._scrollBased) {
          this._targetTween.play();
        }

        return this._onlyOnce ? observer.unobserve(entry.target) : null;
      }

      if (!entry.isIntersecting && !this._infinite && !(0, _isEmptyObject.default)(this._targetTween)) {
        this._targetTween.pause();
      }

      return null;
    }));
    (0, _defineProperty2.default)(this, "handleCallback", entry => {
      if (this._callback) {
        return this._callback(entry);
      }

      return null;
    });
    (0, _defineProperty2.default)(this, "takeRecords", () => {
      this.observer.takeRecords();
    });
    (0, _defineProperty2.default)(this, "unObserve", element => {
      const targets = this._buildElement(element, this._targetMultiple);

      return targets.map(target => this.observer.unobserve(target));
    });
    (0, _defineProperty2.default)(this, "destroy", () => {
      this.observer.disconnect();

      if (!(0, _isEmptyObject.default)(this._targetTween)) {
        this._targetTween.kill();
      }
    });
    this._root = root;
    this._rootMargin = rootMargin;
    this._threshold = _threshold;
    this._thresholdSteps = thresholdSteps;
    this._targetElement = targetElement;
    this._targetMultiple = _targetMultiple;
    this._onlyOnce = onlyOnce;
    this._targetTween = targetTween;
    this._scrollBased = scrollBased;
    this._infinite = infinite;
    this._reverse = reverse;
    this._callback = callback;

    this._createObserver();
  }

}

var _default = Scrollix;
exports.default = _default;